import axios from '../utils/axios';

export default function fetchCourseRecruiter(adminId, courseId, params) {
    return (
        axios.get('/admin/' + adminId + '/courses/course/change-recruiter/' + courseId, { params })
    )
}
